import { z } from 'zod';

const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);

export const OnlinePerformanceDailySchema = z.array(z.object({
  date: z.string(),
  brand_name: z.string(),
  brand_manager: z.string().nullable(),
  merch_portfolio: z.string().nullable(),
  ordered_items: num(),
  delivered_items: num(),
  cancelled_items: num(),
  rtoed_items: num(),
  returned_items: num(),
  gross_gmv: num(),
  /* Gross GMV of orders not in CANCELLED / RTO / RETURNED / RETURN_WIP /
     UNFULFILLABLE status, excluding exchanges. Distinct from "Net GMV"
     (a different merch metric). */
  gross_gmv_net_rc: num(),
  mto_items: num(),
  onhand_items: num(),
  jit_items: num(),
  /* MTC split (added 2026-06-10, card 8129). Optional so older cached
     responses still parse. */
  mtc_items: num().optional().default(0),
  mto_gmv: num(),
  onhand_gmv: num(),
  jit_gmv: num(),
  mtc_gmv: num().optional().default(0),
  spend: num(),
  gross_roas: numNull(),
  net_rc_roas: numNull(),
  /* Halo ROAS components (added 2026-07-16, card 8129). Meta-attributed
     purchase value (meta_gmv) and Meta ad spend (meta_spend) per brand-day.
     Optional so older cached responses still parse; halo_roas is derived
     frontend-side as sum(meta_gmv) / sum(meta_spend). */
  meta_gmv: num().optional().default(0),
  meta_spend: num().optional().default(0),
}));
export type OnlinePerformanceDaily = z.infer<typeof OnlinePerformanceDailySchema>;
